import React, {useCallback, useContext, useEffect, useReducer, useState} from 'react';
import {
	Backdrop,
	Button,
	Checkbox, CircularProgress, Dialog, DialogActions, DialogContent,
	DialogContentText, DialogTitle,
	Divider,
	FormControlLabel,
	Paper,
	Typography
} from "@mui/material";
import {useParams} from "react-router-dom";
import clsx from 'clsx';
import Grid from "@mui/material/Grid";
import {FormProvider, useForm} from "react-hook-form";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from '@mui/material/Alert';
import Background from "../../../assets/Ocean-bg.jpg";
import IconButton from "@mui/material/IconButton";
import Brightness4TwoToneIcon from "@mui/icons-material/Brightness4TwoTone";
import Brightness5TwoToneIcon from "@mui/icons-material/Brightness5TwoTone";
import Tooltip from "@mui/material/Tooltip";
import {useTheme} from "@mui/styles";
import {ContattaciStyle} from "../../../styles/pages/contact/ContattaciStyle";
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import {AppContext} from "../../../App";
import {setCloseSnackbar, setOpenSnackbar, setThemeType} from "../../../services/AppServices";
import {SegnalazionePositivoGrid} from "./SegnalazionePositivoGrid";
import CustomMultiText from "../../widgets/inputs/CustomMultiText";
import {bigNoteRegisterNotRequired} from "../../../utils/RegisterUtils";
import Copyright from "../../auth/utils/Copyright";
import SimpleDialog from "../../widgets/dialogs/SimpleDialog";
import {OCEAN__MAIN_GLOBAL_THEMA_TEXT, OCEAN__GLOBAL_THEMA_TEXT_DARK} from "../../../strings/IT";
import {initIntervistaState, INTERVISTA_INITIAL_STATE, IntervistaReducer} from "../../../reducers/IntervistaReducer";
import {initQuaranteneState, QUARANTENE_INITIAL_STATE, QuaranteneReducer} from "../../../reducers/QuaranteneReducer";
import {generateIntervistaV2, setIntervista} from "../../../services/IntervistaServices";
import {getIntervistaApiData, getListaOf} from "../../../services/utils/IntervistaApiData";
import {generateQuarantenaV3} from "../../../services/QuaranteneServices";
import {sintomi} from "../../../utils/arrays/Generics";
import {AnagraficaCompleta} from "../../widgets/common/AnagraficaCompleta";
import {addAnagrafica} from "../../../services/TicketServices";
import { Alert, AlertTitle } from '@mui/material';
import {RadioGroupQuestion} from "../../widgets/inputs/RadioGroupQuestion";


const IntervistaContatto = () => {
	const contattaciClasses = ContattaciStyle();
	const classes = BaseStyle();
	let theme = useTheme();
	
	const methods = useForm({
		mode: "onChange",
	});
	
	const [idSoggetto, setIdSoggetto] = useState("");
	const [submit, setSubmit] = useState(false);
	const [submitQuarantena, setSubmitQuarantena] = useState(false);
	const [success, setSuccess] = useState(false);
	const appContext = useContext(AppContext);
	const [intervistaState, intervistaDispatch] = useReducer(IntervistaReducer, INTERVISTA_INITIAL_STATE, initIntervistaState);
	const [quarantenaState, quarantenaDispatch] = useReducer(QuaranteneReducer, QUARANTENE_INITIAL_STATE, initQuaranteneState);
	const [openInformativa, setOpenInformativa] = useState(true);
	const [read, setRead] = useState(false);
	let {idFocolaio} = useParams();
	
	const handleCloseSnack = useCallback(() => {
		setCloseSnackbar(appContext.dispatch);
	}, [appContext.dispatch]);
	
	const onSubmit = useCallback((data) => {
		setIntervista(data, intervistaDispatch)
		addAnagrafica(data.soggetto, (id) => {
			setIdSoggetto(id);
			setSubmit(true);
			generateIntervistaV2({
				...getIntervistaApiData(data),
				tipoContatto: "Contatto convivente",
				soggetto: {...data.soggetto, idSoggetto: id},
				type: "PUB"
			}, intervistaDispatch, false)
		}).then(() => {
			setSubmit(true);
		})
	}, [intervistaDispatch])
	
	useEffect(() => {
		if (submit && !intervistaState.loadingAddIntervista && intervistaState.errorAddIntervista === "") {
			setSubmit(false);
			setSubmitQuarantena(true);
			let score = Math.round(getListaOf(sintomi, intervistaState.intervista)?.split(",")?.length * 4 / 11)
			generateQuarantenaV3(idSoggetto, methods.getValues(), intervistaState.intervista.id, score, "CON_COV", null, quarantenaDispatch, idFocolaio);
		} else if (submit && !intervistaState.loadingAddIntervista && intervistaState.errorAddIntervista !== "") {
			setSubmit(false);
			setOpenSnackbar("error", intervistaState.errorAddIntervista, appContext.dispatch);
		}
	}, [submit, intervistaState.loadingAddIntervista, intervistaState.errorAddIntervista, idSoggetto,
		quarantenaDispatch, intervistaState.intervista, appContext.dispatch, methods, idFocolaio])
	
	useEffect(() => {
		if (submitQuarantena && !quarantenaState.loadingGenerateQuarantena && quarantenaState.errorGenerateQuarantena === "") {
			setSubmitQuarantena(false);
			setSuccess(true);
		} else if (submitQuarantena && !quarantenaState.loadingGenerateQuarantena && quarantenaState.errorGenerateQuarantena !== "") {
			setSubmitQuarantena(false);
			setOpenSnackbar("error", quarantenaState.errorGenerateQuarantena, appContext.dispatch);
		}
	}, [submitQuarantena, quarantenaState.loadingGenerateQuarantena, quarantenaState.errorGenerateQuarantena, appContext.dispatch])
	
	useEffect(() => {
		setCloseSnackbar(appContext.dispatch);
	}, [appContext.dispatch])
	
	useEffect(() => {
		document.body.style =
			`background-image: url(${Background});
		background-attachment: fixed;
    background-size: cover;`;
	}, []);
	
	return (
        <React.Fragment>
            <Backdrop open={submit} className={classes.backdrop}>
				<CircularProgress color={"inherit"}/>
			</Backdrop>
            <Backdrop open={submitQuarantena} className={classes.backdrop}>
				<CircularProgress color={"inherit"}/>
			</Backdrop>
            <main className={classes.mainNoBgCol}>
				<header className={contattaciClasses.header}>
					<Tooltip
						title={appContext.state.theme.palette.mode === "light" ? OCEAN__MAIN_GLOBAL_THEMA_TEXT : OCEAN__GLOBAL_THEMA_TEXT_DARK}>
						<IconButton
                            className={contattaciClasses.icon}
                            color="inherit"
                            style={{color: appContext.state.theme.palette.mode === "light" ? "#FFF" : "#000"}}
                            onClick={() => setThemeType(appContext.state.theme.palette.mode === "light" ? "dark" : "light",
								appContext.state.theme, appContext.dispatch)}
                            size="large">
							{
								appContext.state.theme.palette.mode === "light" ?
									<Brightness4TwoToneIcon/> :
									<Brightness5TwoToneIcon/>
							}
						</IconButton>
					</Tooltip>
					<Typography variant={"h2"} component={"h1"} className={contattaciClasses.title}>
						<b>Intervista epidemiologica</b>
					</Typography>
				</header>
				<article className={contattaciClasses.article}>
					<Paper
						className={clsx(classes.roundBorder, contattaciClasses.mdWidth, classes.transparent80, classes.blurred20)}>
						<form onSubmit={methods.handleSubmit(onSubmit)}>
							<FormProvider {...methods}>
								<Grid container spacing={3}>
									<Grid item xs={12}>
										<Typography color={"textSecondary"}>
											Gentilissimo utente,<br/>
											hai ricevuto questo link dall'<b>ASL Città di Torino</b> in quanto sei stato segnalato come
											contatto di positivo.<br/>
											Ti invitiamo a compilare l'intervista epidemiologica per informare l'ASL Città di Torino riguardo
											eventuali sintomi.<br/>
											Nel caso in cui tu rientrassi tra coloro che necessitano di quarantena (non autosorveglianza),
											riceverai giornalmente un monitoraggio tramite mail, ti verrà <b>prenotato un
											tampone molecolare o rapido di controllo</b> e verrai contattato il giorno prima del tampone per
											conferma.
										</Typography>
									</Grid>
									<Grid item xs={12}>
										<Alert severity={"info"} style={{borderRadius: 24}}>
											<AlertTitle><b>Alcuni chiarimenti</b></AlertTitle>
											Nel caso tu abbia completato il ciclo vaccinale (prima dose + seconda dose + dose booster) o abbia
											ricevuto la seconda dose da meno di 120 giorni non sarà necessario effettuare alcuna quarantena ma
											solamente 5 giorni di autosorveglianza.<br/>
											<br/>
											
											<b>Ho effettuato solo 2 dosi da più di 120 giorni, come mi comporto?</b><br/>
											Compila questa intervista in modo da indicarci eventuali sintomi o patologie. Ti verrà predisposta
											una quarantena della durata di 5 giorni con tampone di uscita. (il tampone ti verrà
											prenotato automaticamente dopo aver compilato l'intervista).<br/><br/>
											
											<b>Non ho effettuato nessun vaccino, come mi comporto?</b><br/>
											Compila questa intervista in modo da indicarci eventuali sintomi o patologie. Ti verrà predisposta
											una quarantena della durata di 10 giorni con tampone di uscita. (il tampone ti verrà
											prenotato automaticamente dopo aver compilato l'intervista).<br/><br/>
											
											In caso tu abbia bisogno di maggiori chiarimenti ti invito a contattare l'ASL Città di Torino
											tramite il modulo <a href={"https://ocean.aslcittaditorino.it/contattaci"}
											                     target={"_blank"} rel={"noreferrer"}>contattaci</a>.
										</Alert>
									</Grid>
									<Grid item xs={12}>
										<Divider/>
									</Grid>
									<AnagraficaCompleta classes={classes} moreInfo={true} name={"soggetto."} intro={"false"}/>
									<Grid item xs={12}>
										<Divider/>
									</Grid>
									
									<SegnalazionePositivoGrid showAlert={false} isCompagni={false} isCasoIndice={false}/>
									
									<Grid item xs={12}>
										<RadioGroupQuestion
											question={"Vuoi effettuare il tampone molecolare tramite l'Asl Città di Torino?"}
											control={methods.control}
											autoFocus={true}
											defaultValue={""}
											rules={{required: true}}
											name={"protocollo"}
											error={methods.errors["protocollo"]}
										/>
										<Typography color={"textSecondary"}>
											In caso tu decida di effettuare il tampone per conto (<a
											href={"https://ocean.aslcittaditorino.it/farmacieconvenzionate"} target={"_blank"}
											rel={"noreferrer"}>cerca farmacie convenzionate
											qui</a> ) tuo verrai solamente monitorato per quelli
											che sono i tuoi sintomi giornalieri; nel caso tu decida di effettuare il tampone tramite l'Asl ti
											verrà prenotato un tampone <b>molecolare o rapido</b> di controllo al 10° o 7° giorno (a seconda
											della tua
											situazione vaccini
											/ guarigioni) e verrai contattato il giorno prima.
										</Typography>
									</Grid>
									
									<Grid item xs={12}>
										<CustomMultiText
											inputRef={methods.register(bigNoteRegisterNotRequired)}
											name={"noteQuarantena"}
											label={"Note particolari da indicare all'operatore"}
											autoFocus={false}
											error={methods.errors["noteQuarantena"]}
											rows={10}
										/>
									</Grid>
									
									<Grid item xs={12}>
										<Divider/>
									</Grid>
									<Grid item xs={12}>
										<Typography color={"textSecondary"}>
											Una volta compilata l'intervista ed indicato correttamente tutti i campi, un
											operatore ti contatterà.
										</Typography>
									</Grid>
									
									<Grid item xs={12} style={{display: "flex", justifyContent: "center"}}>
										<Button variant={"contained"} color={"primary"} disableElevation className={classes.roundButton}
										        onClick={methods.handleSubmit(onSubmit)} disabled={submit}
										        style={{fontSize: 18, borderRadius: 24}}>
											<b>Invia intervista</b>
										</Button>
									</Grid>
								
								</Grid>
							</FormProvider>
						</form>
					</Paper>
				</article>
				<footer style={{marginTop: "8%", display: "flex", flexDirection: "column"}}>
					<Copyright/>
				</footer>
			</main>
            <Snackbar open={appContext.state.open} autoHideDuration={3000} onClose={handleCloseSnack}>
				<SnackAlert style={{borderRadius: 28}} onClose={handleCloseSnack}
				            severity={appContext.state.severity}>
					{appContext.state.message}
				</SnackAlert>
			</Snackbar>
            <SimpleDialog
				open={openInformativa}
				title={"Benvenuto su Atlantis!"}
				content={
					<DialogContentText component={"div"}>
						<b>Informativa e privacy</b><br/>
						
						Gentile Sig./Sig.ra,<br/>
						
						<br/>
						I dati personali che conferirà con la compilazione del presente modulo on line saranno trattati utilizzando
						modalità manuali, informatiche e telematiche, nel rispetto e nei limiti stabiliti dalla normativa
						vigente.<br/>
						<br/>
						DICHIARAZIONE DI PRESA VISIONE DELL’INFORMATIVA PRIVACY. Dichiaro di avere letto e preso conoscenza delle
						informazioni, rese ai sensi dell’art. 13 del Regolamento UE 2016/679, relative al trattamento dei miei dati
						personali, pubblicate alla pagina web {" "}
						<a style={{color: theme.palette.primary.main}}
						   href={"https://www.regione.piemonte.it/web/note-legali-privacy"}
						   target="_blank"
						   rel="noreferrer">https://www.regione.piemonte.it/web/note-legali-privacy</a>.<br/>
						<FormControlLabel
							control={
								<Checkbox
									color={"primary"}
									checked={read}
									onChange={() => setRead(!read)}
									name="read"/>
							}
							label={"Ho letto integralmente e compreso l'informativa sul trattamento dei dati personali"}
						/>
					</DialogContentText>
				}
				actions={
					<DialogActions>
						<Button variant={"contained"} disableElevation size={"small"} className={classes.roundButton}
						        color={"primary"} style={{borderRadius: 24}}
						        onClick={() => setOpenInformativa(false)} disabled={!read}>
							<b>Confermo</b>
						</Button>
					</DialogActions>
				}
			/>
            {
				success && <Dialog open={success} PaperProps={{
					className: clsx(classes.roundBorder)
				}}>
					<DialogTitle>
						<b>Ottimo lavoro! 👍</b>
					</DialogTitle>
					<DialogContent>
						<DialogContentText>
							Hai completato l'intervista! resta a disposizione per eventuali chiamate dagli
							operatori dell' ASL.<br/>
							Ora puoi chiudere questa finestra o tab, riceverai ulteriori comunicazioni da un'operatore dell'ASL.
						</DialogContentText>
					</DialogContent>
				</Dialog>
			}
        </React.Fragment>
    );
};

function SnackAlert(props) {
	return <MuiAlert elevation={16} variant="filled" {...props} />;
}

export default React.memo(IntervistaContatto);
